import React from "react";
import { ConversationForm } from "../common";

export default function ContactDetailsSection({ data }) {
  if (!data) return null;

  return (
    <section className="contact-details-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="contact-details-intro">
              <span>{data.eyebrow}</span>
              <h2 className="heading">{data.title}</h2>
              <p>{data.description}</p>
            </div>
          </div>
        </div>

        <div className="row contact-details-layout">
          <div className="col-lg-6">
            <div className="contact-information">
              <ul>
                <li>
                  <i className="fa-solid fa-phone" aria-hidden="true" />
                  <a href={`tel:${data.phone.replace(/\s/g, "")}`}>
                    {data.phone}
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-envelope" aria-hidden="true" />
                  <a href={`mailto:${data.email}`}>{data.email}</a>
                </li>
                <li>
                  <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  <address>{data.address}</address>
                </li>
              </ul>

              <iframe
                className="contact-map"
                src={data.mapEmbedUrl}
                title={data.mapTitle}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="contact-form-wrap">
              <ConversationForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
